module.exports = __webpack_public_path__ + "static/media/earn.15f0b5ea.gif";